<template>
<div class="search-and-find custom-scrollbar-light hide-bottom-scrollbar">
<div class="find-top">

	<div class="find-title">
            <h4>Find</h4>

          <button  type="reset" @click="$emit('toggle-search')" >  
               <i class="fa-light fa-times"></i>
          </button> 
    </div>

        <form class="d-flex search-list"  @submit.stop.prevent>
            <div style="margin: 10px 20px 10px; height:65px;">               
                <div class="d-flex input-wrapper">
                    <input :placeholder="$t('section-search.placeholder')" autocomplete="off" id="searchInput" ref="searchInput" type="text" v-model="searchQuery">
                    <button  type="submit" @click="search(searchQuery)">
                        <i class="fa-light fa-search"></i>
                    </button>
                </div>
                <label v-if="recentSearch" for="searchInput" class="result-length small">{{$t('section-search.found')}} <span class="text-bold">{{results.length}}</span>{{$t('section-search.variants')}} <span class="text-bold"> {{recentSearch}}</span></label>

            </div>
        </form>

</div>
    
    <div class="resultlist">
        <div class="result-card"  v-for="(result, index) in results" :key="result.id">    
            <div @click="focusResult(index, result)" >
                <search-result class="search-result" :result="result"  :class="{'active': index == activeIndex}"  :searchUpdated="searchUpdated"/>           
            </div>     
        </div>
    </div>
</div>
	
</template>

<script>
    import EventBus from "@/assets/js/eventBus.js";
    import SearchResult from '@/components/SearchResult'
	export default {
		name: 'SearchAndFind',
		props: {
            section: Object
		},
		data() {
			return {
            recentSearch: null,
            searchQuery: "",
            results: [],
            activeIndex: null,
            searchUpdated: false
			}
		},
		computed: {
     
		},
        methods: {
            search (query) {
                if(!query){
                    this.results=[]
                    this.recentSearch= null
                }
                else{
                this.results = []
                this.results = this.section.search(query, [])
                this.recentSearch = query
                this.searchUpdated = !this.searchUpdated
                }
            },
        
        focusResult(index, result){
            this.activeIndex = index
        },


        handlePopover(){
            this.$emit('close')
        }
         
        },
        created(){
              this.$nextTick(() => {
                const inputField =  this.$refs.searchInput
                inputField.focus();
            });
        },
        mounted(){
            EventBus.$on("popover-opened", this.handlePopover);
        },
        destroyed(){
            EventBus.$off("popover-opened");
        },

        components:{
            SearchResult
        }
    
    
    }
</script>

<style lang="less">
	.search-and-find{
        color: var(--charcoal);
        // height: calc(100% - 10px);
        background: var(--background-white);
        border-radius: var(--standard-border-radius);
        padding-bottom: 10px;
        .find-top{
            position: fixed;
            background: #fff;
            width: 300px;
            -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            box-shadow:  0px 4px 4px rgba(0, 0, 0, 0.247);
            border-radius: var(--standard-border-radius) !important;
            img{
                width: 16px;
            }
        }
        .find-title{    
            padding: 14px 20px;
            text-transform: uppercase;
            display: flex;
            justify-content: space-between;
            align-items: center;
            -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            box-shadow:  0px 4px 4px rgba(0, 0, 0, 0.247);
            h4{
                margin-bottom: 0;
            }
            
            button{
                  color: #8F979C;
                  &:hover{
                    color: #383838;
                }
            }
        }
           button{
                border: none;
                background: inherit;
            }
        form{
            
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            label{
                margin: 5px 0;
                text-overflow: ellipsis;
                overflow: hidden; 
                white-space: nowrap;
                    width: 260px; 
            }
        }
        .input-wrapper{
            justify-content: space-between;
            border-bottom: 1px solid #3d464a1e;
            transition: .4s;
            padding: 10px 0;
         &:focus-within{
                border-bottom: 1px solid #3d464a;
            }

            button{
                  color: #8F979C;
                  &:hover{
                    color: #383838;
                }
            }
        }
        input{
            width: 240px;
            border: none;
            line-height: 24px;
            word-break: break-word;
            &:focus{
            outline:0;
            }
        
        }
        .text-bold{
            font-weight: 900;
            cursor: default;
        }
        .resultlist{
            background: #fff;
            // overflow: scroll;
            overflow: auto;
            margin-top: 140px;
            border-radius: var(--standard-border-radius);
                .result-card{ 
                    margin: 10px;
                    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.25);
                    background-color: #fff;
                }
        }
        .search-result{
            transition: .3s;
              &:hover:not(.active){
                        background-color: #f3f3f3;
                    }
        }
        .active{
            box-shadow: 4px 4px 14px 4px rgba(0, 0, 0, 0.336);
            background-color: #ffffff;
            // transform: scale(1.01)
        }
 
    }
</style>

